function PriceDiscount(props) {
  const { oldPrice, newPrice, className } = props;

  return (
    <p className={className}>
      <span className="font-extrabold text-blue-1">{newPrice} جم</span>
      {oldPrice && (
        <span className="mr-2 text-gray-500 line-through">{oldPrice} جم</span>
      )}
    </p>
  );
}

export default PriceDiscount;
